import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

export default function WorklistPagination({ page, total, pageSize, onPageChange }) {
    const totalPages = Math.ceil(total / pageSize);
    if (totalPages <= 1) return null;

    const from = (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, total);

    // Build page numbers: show max 5 pages with ellipsis
    const pages = [];
    if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
        pages.push(1);
        if (page > 3) pages.push('...');
        const start = Math.max(2, page - 1);
        const end = Math.min(totalPages - 1, page + 1);
        for (let i = start; i <= end; i++) pages.push(i);
        if (page < totalPages - 2) pages.push('...');
        pages.push(totalPages);
    }

    const btn = (disabled, onClick, children, active = false) => (
        <button
            disabled={disabled}
            onClick={onClick}
            className={`min-w-[32px] h-8 px-2 flex items-center justify-center rounded-lg text-xs font-semibold transition-all
                ${active
                    ? 'bg-indigo-600 text-white shadow-sm shadow-indigo-500/20'
                    : 'text-gray-600 dark:text-slate-400 hover:bg-gray-100 dark:hover:bg-slate-800'
                }
                ${disabled ? 'opacity-40 pointer-events-none' : 'cursor-pointer'}
            `}
        >
            {children}
        </button>
    );

    return (
        <div className="flex items-center justify-between py-3 text-xs">
            <span className="text-gray-500 dark:text-slate-400 font-medium">
                Showing {from}–{to} of {total.toLocaleString()} entries
            </span>
            <div className="flex items-center gap-1">
                {btn(page === 1, () => onPageChange(1), <ChevronsLeft className="w-3.5 h-3.5" />)}
                {btn(page === 1, () => onPageChange(page - 1), <ChevronLeft className="w-3.5 h-3.5" />)}
                {pages.map((p, i) =>
                    p === '...'
                        ? <span key={'e' + i} className="px-1 text-gray-400">…</span>
                        : btn(false, () => onPageChange(p), p, p === page)
                )}
                {btn(page === totalPages, () => onPageChange(page + 1), <ChevronRight className="w-3.5 h-3.5" />)}
                {btn(page === totalPages, () => onPageChange(totalPages), <ChevronsRight className="w-3.5 h-3.5" />)}
            </div>
        </div>
    );
}
